<template>
  <Layout>
    <div style="width: 100%;">
      <div class="row" style="margin-bottom: 15px;">
        <div class="col">
          <q-select v-model="company" :options="companyOptions" label="Company" style="margin-right: 10px;"/>
        </div>
        <div class="col">
          <q-select v-model="status" :options="statusOptions" label="Status"/>
        </div>
        <div class="col"></div>
      </div>
      <q-card class="flexbox justify-center" style="min-height: 250px">
        <q-inner-loading
            :showing="loading"
            label="Please wait..."
            label-class="text-teal"
            label-style="font-size: 1.1em"
        />
        <div v-if="count > 0 && !loading">
          <q-table
              ref="table"
              title="Invoices"
              :data="items"
              :columns="columns"
              row-key="name"
              :pagination="{page: 1, rowsPerPage: 0}"
              hide-bottom
              class="no-shadow"
          >
            <template v-slot:body="props">
              <q-tr :props="props">
                <q-td key="company" :props="props" style="width: 25%">
                  <span style="font-weight: bold">
                    {{ props.row.company }}
                  </span>
                </q-td>
                <q-td key="months" :props="props" style="width: 25%">
                  {{ props.row.months }} month<span v-if="props.row.months > 1">s</span>
                </q-td>
                <q-td key="amount" :props="props" style="width: 25%">{{ props.row.amount }}</q-td>
                <q-td key="createdAt" :props="props" style="width: 25%">{{
                    props.row.createdAt | dateTimeFormat
                  }}
                </q-td>
                <q-td key="dueDate" :props="props" style="width: 25%">{{ props.row.dueDate | dateFormat }}</q-td>
                <q-td key="paidAt" :props="props" style="width: 25%">
                  <q-chip square color="red" text-color="white" label="Unpaid" v-if="props.row.paidAt === null"/>
                  <q-chip square color="green" text-color="white" label="Paid" v-else/>
                </q-td>
                <q-td key="id" :props="props">
                  <q-btn
                      size="sm"
                      @click="$router.push('/invoice/' + props.row.id)"
                      class="q-mr-sm"
                      color="secondary"
                  >Show
                  </q-btn>
                </q-td>
              </q-tr>
            </template>
          </q-table>
          <div class="q-pa-lg flex flex-center" v-if="!this.loading">
            <q-pagination
                v-model="pagination.page"
                :max="pagination.last"
                :max-pages="5"
                @input="getInvoices"
                boundary-numbers
                direction-links
            />
          </div>
        </div>
        <p class="self-center" v-if="count === 0 && !loading">Invoice not found.</p>
      </q-card>
    </div>
  </Layout>
</template>

<script>
import Layout from '../components/Layout'
import axios from '../axios/index'

export default {
  components: {
    Layout,
  },

  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        per: 10,
        last: 0,
      },
      count: 0,
      columns: [
        {name: 'company', label: 'Company', field: 'company.name'},
        {name: 'months', label: 'Period', field: 'months'},
        {name: 'amount', label: 'Amount', field: 'amount'},
        {name: 'createdAt', label: 'Created at', field: 'createdAt'},
        {name: 'dueDate', label: 'Due date', field: 'dueDate'},
        {name: 'paidAt', label: 'Status', field: 'paidAt'},
        {name: 'id', label: 'Actions', field: 'id'},
      ],
      status: {label: 'All', value: null},
      statusOptions: [
        {label: 'All', value: null},
        {label: 'Unpaid', value: 'false'},
        {label: 'Paid', value: 'true'},
      ],
      company: {label: 'All', value: null},
      companyOptions: [
        {label: 'All', value: null},
      ],
      items: []
    }
  },
  methods: {
    async getInvoices() {
      this.loading = true
      this.items = []

      try {
        const params = {
          page: this.pagination.page,
          per: this.pagination.per,
        }

        if (this.company.value) {
          params.company = this.company.value
        }

        if (this.status.value) {
          params.is_paid = this.status.value
        }

        const {data} = await axios.get('/invoices', {params})

        this.pagination.last = data.data.pagination.last
        this.count = data.data.count

        if (data.data.items.length > 0) {
          for (const key in data.data.items) {
            this.items.push({
              company: data.data.items[key].company.name,
              months: data.data.items[key].months,
              amount: `$${data.data.items[key].amount}`,
              createdAt: data.data.items[key].created_at,
              dueDate: data.data.items[key].due_date,
              paidAt: data.data.items[key].paid_at,
              id: data.data.items[key].id,
            })
          }
        }
      } catch (err) {
        this.$q.notify({
          message: err.message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'positive'
        })
      } finally {
        this.loading = false
      }
    },
    async getCompanies() {
      try {
        const {data} = await axios.get('/companies')
        if (data.data.length > 0) {
          for (const key in data.data) {
            this.companyOptions.push({
              label: data.data[key].name,
              value: data.data[key].id,
            })
          }
        }
      } catch (err) {
        this.$q.notify({
          type: 'negative',
          message: err.message,
          timeout: 250,
          progress: true,
          position: 'top-right',
        })
      }
    },
    async onChangeStatus(status) {
      console.log(status)
    },
  },
  mounted() {
    this.getCompanies()
    this.getInvoices()
  },
  watch: {
    async company(newValue, oldValue) {
      if (newValue !== oldValue) {
        await this.getInvoices()
      }
    },
    async status(newValue, oldValue) {
      if (newValue !== oldValue) {
        await this.getInvoices()
      }
    },
  },
}
</script>
